import React from "react";
import { Button } from "antd";
import { AuthStep } from "@pages/Onboarding/Onboarding";
import styles from "@entities/Onboarding/ui/styles.module.scss";

interface CheckEmailProps {
  navigateTo: (step: AuthStep) => void;
}

export const CheckEmail: React.FC<CheckEmailProps> = ({ navigateTo }) => {
  return (
    <div className={styles.fadeIn}>
      <h2 className={styles.checkEmailTitle}>Check your email</h2>
      <p className={styles.description}>
        Thanks! If{" "}
        <span className={styles.emailHighlight}>name@company.com</span> matches
        an email address we have on file, then we've sent you an email
        containing further instructions for resetting your password.
      </p>
      <p className={styles.description}>
        If you haven't received an email in 5 minutes, check your spam,{" "}
        <a className={styles.link}>resend</a>, or{" "}
        <a
          onClick={() => navigateTo("FORGOT_PASSWORD")}
          className={styles.link}
        >
          try a different email address
        </a>
        .
      </p>
      <div className={styles.centerText}>
        <Button type="link" onClick={() => navigateTo("LOGIN")}>
          Return to sign in
        </Button>
      </div>
    </div>
  );
};
